class ScrollToTop {
  constructor() {
    this.createButton();
    this.initEventListeners();
    this.lastScrollTop = 0;
    this.scrollingDown = true;
    this.isAnimating = false;
  }

  createButton() {
    if (!document.querySelector('.scroll-to-top')) {
      const button = document.createElement('button');
      button.className = 'scroll-to-top';
      button.setAttribute('aria-label', 'Scroll to top');
      button.setAttribute('title', 'Scroll to top');
      
      button.innerHTML = `
<svg data-name="1-Arrow Up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="m26.71 10.29-10-10a1 1 0 0 0-1.41 0l-10 10 1.41 1.41L15 3.41V32h2V3.41l8.29 8.29z"/></svg>
      `;
      
      document.body.appendChild(button);
    }
    
    this.button = document.querySelector('.scroll-to-top');
  }

  initEventListeners() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.button.addEventListener('click', this.handleClick.bind(this));
  }

  handleScroll() {
    if (this.isAnimating) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 300;
    
    this.scrollingDown = scrollTop > this.lastScrollTop;
    this.lastScrollTop = scrollTop;
    
    if (scrollTop > scrollThreshold && !this.scrollingDown) {
      this.button.classList.add('show');
    } else {
      this.button.classList.remove('show');
    }
  }

  handleClick() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    
    this.button.classList.add('animate-click');
    this.smoothScrollTop();
    
    setTimeout(() => {
      this.button.classList.remove('animate-click');
      this.button.classList.remove('show');
      this.isAnimating = false;
    }, 350);
  }

  smoothScrollTop() {
    const duration = 350;
    const start = window.pageYOffset || document.documentElement.scrollTop;
    const distance = start;
    const startTime = performance.now();
    
    const animateScroll = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      
      window.scrollTo(0, start - (distance * progress));
      
      if (progress < 1) {
        window.requestAnimationFrame(animateScroll);
      }
    };
    
    window.requestAnimationFrame(animateScroll);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ScrollToTop();
  });
} else {
  new ScrollToTop();
} 